@if (userService.isAuthenticated) {
    <vn-login-duration />
}

<div class="breadcrumb modal-breadcrumb">
    <div class="breadcrumb-back modal-back" (click)="close()">
        <span class="breadcrumb-theme-left"><i class="theme-left modal-theme-left"></i></span>
    </div>
    <ms-event-details-breadcrumb [event]="detailedEventModel.model" />
</div>
<ms-event-details-main class="in-overlay" [detailedEventModel]="detailedEventModel" />
